import Tooltip from "@intility/bifrost-react/Tooltip";
import { adminConsentUrl } from "~/api/companies";
import type { OnboardedTenant } from "~/api/types";
import { CopyButton } from "~/components/CopyButton";

// The GDAP admin user is logged in on another machine, not in the browser that
// runs the Portal. The operator copies the consent URL and opens it there. So
// the consent URL is a copy button, not a link.
export function ConsentCopyButton({ tenantId }: { tenantId: string }) {
  return (
    <CopyButton value={adminConsentUrl(tenantId)}>copy consent link</CopyButton>
  );
}

function syncState(tenant: OnboardedTenant): { text: string; alert: boolean } {
  if (tenant.lastError) return { text: tenant.lastError, alert: true };
  if (tenant.lastSuccessAt)
    return {
      text: `Synced ${new Date(tenant.lastSuccessAt).toLocaleString()}`,
      alert: false,
    };
  return { text: "Not synced yet", alert: false };
}

// Each tenant of a company with the worker's last result and its unclaimed-domain conflicts.
export function TenantList({ tenants }: { tenants: OnboardedTenant[] }) {
  if (tenants.length === 0) return <span>No tenant</span>;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {tenants.map((tenant) => {
        const state = syncState(tenant);
        return (
          <div
            key={tenant.tenantId}
            style={{ display: "flex", flexDirection: "column", gap: 4 }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <code>{tenant.tenantId}</code>
              <CopyButton value={tenant.tenantId} regularIcon />
            </div>
            <div>
              <ConsentCopyButton tenantId={tenant.tenantId} />
            </div>
            <div
              className="bf-small"
              style={{
                marginTop: 4,
                color: state.alert ? "var(--bfc-alert)" : "var(--bfc-base-c-2)",
              }}
            >
              {state.text}
            </div>
            {tenant.unclaimedDomainConflicts > 0 && (
              <Tooltip content="Users of the tenant whose email domain no company claims. Add the domain to the company that owns it.">
                <div
                  className="bf-small"
                  style={{ color: "var(--bfc-warning)" }}
                >
                  {tenant.unclaimedDomainConflicts} users with an unclaimed
                  domain
                </div>
              </Tooltip>
            )}
          </div>
        );
      })}
    </div>
  );
}
